/**
 * RB Innovations Australia — Product Page JS
 * File: assets/rbi-product.js
 */

(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initAccordions();
    initGallery();
    initVariants();
    initQuantity();
    initStickyBar();
    initRecentlyViewed();
    initCarousel();
    initCartForm();
  }

  /* ═══════════════════════════════════════════════════════════
     ACCORDION
  ═══════════════════════════════════════════════════════════ */
  function initAccordions() {
    $$('[data-accordion]').forEach(acc => {
      const trigger = $('.rbi-accordion__trigger', acc);
      const panel   = $('.rbi-accordion__panel', acc);
      if (!trigger || !panel) return;
      trigger.addEventListener('click', () => {
        const isOpen = trigger.classList.contains('is-open');
        $$('[data-accordion]').forEach(other => {
          const t = $('.rbi-accordion__trigger', other);
          const p = $('.rbi-accordion__panel', other);
          if (t && p && other !== acc) {
            t.classList.remove('is-open');
            t.setAttribute('aria-expanded', 'false');
            p.classList.remove('is-open');
            p.setAttribute('hidden', '');
          }
        });
        if (isOpen) {
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        } else {
          trigger.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
          panel.removeAttribute('hidden');
        }
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     GALLERY — slides, thumbnails, swipe, lightbox
  ═══════════════════════════════════════════════════════════ */
  function initGallery() {
    const gallery  = $('#rbi-gallery');
    if (!gallery) return;

    const slides   = $$('.rbi-gallery__slide', gallery);
    const thumbs   = $$('.rbi-gallery__thumb', gallery);
    const counter  = $('#rbi-slide-current');
    const prevBtn  = $('#rbi-prev');
    const nextBtn  = $('#rbi-next');
    const mainArea = $('#rbi-gallery-main');

    const lightbox   = $('#rbi-lightbox');
    const lbImg      = $('#rbi-lightbox-img');
    const lbClose    = $('#rbi-lightbox-btn');
    const lbBackdrop = $('#rbi-lightbox-backdrop');
    const lbPrev     = $('#rbi-lb-prev');
    const lbNext     = $('#rbi-lb-next');
    const lbCounter  = $('#rbi-lb-counter');

    // Move lightbox to body so Dawn cannot clip or overlap it
    if (lightbox && lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    let current = 0;
    const total = slides.length;

    function goTo(idx) {
      if (total === 0) return;
      if (idx < 0) idx = total - 1;
      if (idx >= total) idx = 0;
      slides[current].classList.remove('is-active');
      thumbs[current]?.classList.remove('is-active');
      thumbs[current]?.setAttribute('aria-current', 'false');
      current = idx;
      slides[current].classList.add('is-active');
      if (counter) counter.textContent = current + 1;
      const thumb = thumbs[current];
      if (thumb) {
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
        thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    function lbShow(idx) {
  if (!lbImg) return;
  if (idx < 0) idx = total - 1;
  if (idx >= total) idx = 0;
  current = idx;
  const slide = slides[idx];
  const img   = slide?.querySelector('img');
  if (!img) return;
  lbImg.src = slide.dataset.full || img.src;
  lbImg.alt = img.alt;
  if (lbCounter) lbCounter.textContent = (idx + 1) + ' / ' + total;
}

    function openLightbox(idx) {
      if (!lightbox) return;
      lbShow(idx);
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(() => lbClose?.focus(), 60);
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    prevBtn?.addEventListener('click', () => goTo(current - 1));
    nextBtn?.addEventListener('click', () => goTo(current + 1));

    let swipeX = 0;
    mainArea?.addEventListener('touchstart', e => { swipeX = e.changedTouches[0].clientX; }, { passive: true });
    mainArea?.addEventListener('touchend', e => {
      const d = e.changedTouches[0].clientX - swipeX;
      if (Math.abs(d) > 40) goTo(d < 0 ? current + 1 : current - 1);
    }, { passive: true });

    mainArea?.addEventListener('click', e => {
      if (window.innerWidth < 750) return;
      if (e.target.closest('#rbi-prev, #rbi-next')) return;
      openLightbox(current);
    });

    lbClose?.addEventListener('click', closeLightbox);
    lbBackdrop?.addEventListener('click', closeLightbox);
    lbPrev?.addEventListener('click', () => lbShow(current - 1));
    lbNext?.addEventListener('click', () => lbShow(current + 1));

    let lbSwipeX = 0;
    lightbox?.addEventListener('touchstart', e => { lbSwipeX = e.changedTouches[0].clientX; }, { passive: true });
    lightbox?.addEventListener('touchend', e => {
      const d = e.changedTouches[0].clientX - lbSwipeX;
      if (Math.abs(d) > 40) lbShow(d < 0 ? current + 1 : current - 1);
    }, { passive: true });

    document.addEventListener('keydown', e => {
      if (!lightbox?.classList.contains('is-open')) return;
      if (e.key === 'Escape')     closeLightbox();
      if (e.key === 'ArrowLeft')  lbShow(current - 1);
      if (e.key === 'ArrowRight') lbShow(current + 1);
    });

    window.RBI = window.RBI || {};
    window.RBI.galleryGoTo   = goTo;
    window.RBI.gallerySlides = slides;
  }

  /* ═══════════════════════════════════════════════════════════
     VARIANT SWITCHING
  ═══════════════════════════════════════════════════════════ */
  function initVariants() {
    const productJSON = $('#rbi-product-json');
    if (!productJSON) return;
    let product;
    try { product = JSON.parse(productJSON.textContent); } catch { return; }

    const optionBtns   = $$('.rbi-option-btn');
    const variantInput = $('#rbi-variant-id');
    const atcBtn       = $('#rbi-atc-btn');
    const stickyAtc    = $('#rbi-sticky-atc');
    const priceBlock   = $('#rbi-price-block');
    const skuValue     = $('#rbi-sku-value');
    const stickyPrice  = $('#rbi-sticky-price');

    const selectedOptions = {};
    product.options.forEach((_, i) => {
      const activeBtn = $(`.rbi-option-btn[data-option-position="${i + 1}"].is-active`);
      selectedOptions[i + 1] = activeBtn?.dataset.value || product.variants[0]['option' + (i + 1)];
    });

    function findVariant() {
      return product.variants.find(v =>
        product.options.every((_, i) => v['option' + (i + 1)] === selectedOptions[i + 1])
      ) || null;
    }

    function fmt(cents) {
      return '$' + (cents / 100).toFixed(2) + ' AUD';
    }

    function updateUI(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceBlock) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        /* Update price text in place instead of rewriting innerHTML.
           innerHTML rewrites cause a one-frame reflow that shifts the
           Afterpay note below, creating a visible gap-open-then-close. */
        let saleEl    = priceBlock.querySelector('.rbi-price--sale');
        let regEl     = priceBlock.querySelector('.rbi-price:not(.rbi-price--sale):not(.rbi-price--compare)');
        let compareEl = priceBlock.querySelector('.rbi-price--compare');
        let badgeEl   = priceBlock.querySelector('.rbi-badge--sale');

        if (sale) {
          /* If the page rendered without sale markup, build it once.
             Otherwise just text-swap the existing nodes. */
          if (!saleEl || !compareEl || !badgeEl) {
            priceBlock.innerHTML =
              `<span class="rbi-price rbi-price--sale">${fmt(variant.price)}</span>` +
              `<span class="rbi-price rbi-price--compare">${fmt(variant.compare_at_price)}</span>` +
              `<span class="rbi-badge rbi-badge--sale">Save ${fmt(variant.compare_at_price - variant.price)}</span>`;
          } else {
            saleEl.textContent    = fmt(variant.price);
            compareEl.textContent = fmt(variant.compare_at_price);
            badgeEl.textContent   = 'Save ' + fmt(variant.compare_at_price - variant.price);
          }
        } else {
          if (!regEl || saleEl || compareEl) {
            priceBlock.innerHTML = `<span class="rbi-price">${fmt(variant.price)}</span>`;
          } else {
            regEl.textContent = fmt(variant.price);
          }
        }
      }
      if (stickyPrice) stickyPrice.textContent = fmt(variant.price);
      if (skuValue) skuValue.textContent = variant.sku || 'N/A';
      [atcBtn, stickyAtc].forEach(btn => {
        if (!btn) return;
        btn.disabled = !variant.available;
        if (btn === atcBtn) {
          btn.innerHTML = variant.available
            ? `<svg class="rbi-cart-icon" viewBox="0 0 24 24" fill="none"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" stroke-width="2"/><path d="M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="2"/></svg>Add to Cart`
            : 'Sold Out';
        } else {
          btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        }
      });
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.featured_image && window.RBI?.galleryGoTo) {
        const idx = window.RBI.gallerySlides?.findIndex(s =>
          s.querySelector('img')?.src.includes(variant.featured_image.id)
        );
        if (idx >= 0) window.RBI.galleryGoTo(idx);
      }
    }

    optionBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const pos = btn.dataset.optionPosition;
        selectedOptions[pos] = btn.dataset.value;
        $$('.rbi-option-btn').forEach(b => {
          if (b.dataset.optionPosition === pos) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          }
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        const lbl = $(`#rbi-selected-${pos}`);
        if (lbl) lbl.textContent = btn.dataset.value;
        updateUI(findVariant());
      });
    });
  }

  /* ═══════════════════════════════════════════════════════════
     QUANTITY
  ═══════════════════════════════════════════════════════════ */
  function initQuantity() {
    const input  = $('#rbi-qty');
    const minus  = $('#rbi-qty-minus');
    const plus   = $('#rbi-qty-plus');
    const hidden = $('#rbi-form-qty');
    if (!input) return;
    const sync = () => { if (hidden) hidden.value = input.value; };
    minus?.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v > 1) { input.value = v - 1; sync(); }
    });
    plus?.addEventListener('click', () => {
      const v = parseInt(input.value) || 1;
      if (v < 99) { input.value = v + 1; sync(); }
    });
    input.addEventListener('change', () => {
      input.value = Math.max(1, Math.min(99, parseInt(input.value) || 1));
      sync();
    });
  }

  /* ═══════════════════════════════════════════════════════════
     STICKY BAR
  ═══════════════════════════════════════════════════════════ */
  function initStickyBar() {
    const bar       = $('#rbi-sticky-bar');
    const row       = $('#rbi-purchase-row');
    const atcForm   = $('#rbi-atc-form');
    const stickyAtc = $('#rbi-sticky-atc');
    if (!bar || !row || window.innerWidth > 749) return;
    bar.setAttribute('aria-hidden', 'false');
    new IntersectionObserver(([e]) => bar.classList.toggle('is-visible', !e.isIntersecting), { threshold: 0 }).observe(row);
    stickyAtc?.addEventListener('click', () => atcForm?.requestSubmit ? atcForm.requestSubmit() : atcForm?.submit());
  }

  /* ═══════════════════════════════════════════════════════════
     RECENTLY VIEWED
  ═══════════════════════════════════════════════════════════ */
  function initRecentlyViewed() {
    const current = window.RBI?.currentProduct;
    if (!current) return;

    let history = [];
    try { history = JSON.parse(localStorage.getItem('rbi_rv') || '[]'); } catch {}
    history = history.filter(p => p.id !== current.id);
    history.unshift(current);
    if (history.length > 10) history = history.slice(0, 10);
    try { localStorage.setItem('rbi_rv', JSON.stringify(history)); } catch {}

    const track = $('#rbi-rv-track');
    if (!track) return;

    const toShow = history.filter(p => p.id !== current.id).slice(0, 6);

    if (toShow.length > 0) {
      $$('[data-fallback]', track).forEach(el => el.remove());
      toShow.forEach(p => {
        const card = document.createElement('div');
        card.className = 'rbi-product-card';
        card.setAttribute('role', 'listitem');
        card.innerHTML = `
          <a href="${ea(p.url)}" class="rbi-product-card__link" aria-label="${ea(p.title)}">
            <div class="rbi-product-card__img-wrap">
              <img src="${ea(p.image)}" alt="${ea(p.title)}" loading="lazy" class="rbi-product-card__img">
            </div>
            <div class="rbi-product-card__info">
              <h3 class="rbi-product-card__title">${eh(p.title)}</h3>
              <span class="rbi-product-card__price">${eh(p.price)}</span>
            </div>
          </a>
          <a href="${ea(p.url)}" class="rbi-btn rbi-btn--card">View Product</a>
        `;
        track.appendChild(card);
      });
    } else {
      const heading = $('#rbi-carousel-heading');
      if (heading) heading.textContent = 'You May Also Like';
    }
  }

  /* ═══════════════════════════════════════════════════════════
     CAROUSEL
  ═══════════════════════════════════════════════════════════ */
  function initCarousel() {
    const track    = $('#rbi-rv-track');
    const viewport = track?.parentElement;
    const prevBtn  = $('#rbi-rv-prev');
    const nextBtn  = $('#rbi-rv-next');
    const dotsWrap = $('#rbi-rv-dots');
    if (!track || !viewport) return;

    let idx = 0;

    function update() {
      const cards = $$('.rbi-product-card', track);
      if (!cards.length) return;
      const cardW = cards[0].offsetWidth + 20;
      const visible = Math.max(1, Math.round(viewport.offsetWidth / cardW));
      const max = Math.max(0, cards.length - visible);
      idx = Math.max(0, Math.min(idx, max));
      track.style.transform = `translateX(-${idx * cardW}px)`;
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        for (let i = 0; i <= max; i++) {
          const dot = document.createElement('button');
          dot.className = 'rbi-carousel-dot' + (i === idx ? ' is-active' : '');
          dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
          dot.addEventListener('click', () => { idx = i; update(); });
          dotsWrap.appendChild(dot);
        }
      }
    }

    prevBtn?.addEventListener('click', () => { idx--; update(); });
    nextBtn?.addEventListener('click', () => { idx++; update(); });

    let tx = 0;
    viewport.addEventListener('touchstart', e => { tx = e.changedTouches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend', e => {
      const d = e.changedTouches[0].clientX - tx;
      if (Math.abs(d) > 40) { d < 0 ? idx++ : idx--; update(); }
    }, { passive: true });

    setTimeout(update, 250);
    window.addEventListener('resize', debounce(update, 200));
  }

  /* ═══════════════════════════════════════════════════════════
     CART FORM — AJAX
     Uses FormData directly so line item properties (e.g. _fulfillment)
     are sent through to /cart/add.js. The previous version manually
     rebuilt the payload with only id + quantity, which stripped out
     hidden inputs like properties[_fulfillment].
  ═══════════════════════════════════════════════════════════ */
  function initCartForm() {
    const form   = $('#rbi-atc-form');
    const atcBtn = $('#rbi-atc-btn');
    if (!form) return;

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!atcBtn) return;
      const orig = atcBtn.innerHTML;
      atcBtn.disabled = true;
      atcBtn.innerHTML = '<span style="display:inline-block;width:18px;height:18px;border:2px solid rgba(255,255,255,0.4);border-top-color:#fff;border-radius:50%;animation:rbi-spin 0.7s linear infinite;vertical-align:middle"></span> Adding…';
      try {
        /* Build a clean payload from the form. Use FormData so any
           hidden inputs (properties[_fulfillment], properties[anything])
           are picked up automatically. */
        const formData = new FormData(form);
        const payload = {
          id: formData.get('id'),
          quantity: parseInt(formData.get('quantity')) || 1,
          properties: {}
        };

        /* Loop through the FormData entries and pull out anything
           that looks like properties[xxx]. Shopify expects properties
           as a nested object, not bracket-notation strings. */
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') {
            payload.properties[match[1]] = value;
          }
        }

        /* If no properties were set, drop the empty object so we don't
           send {properties:{}} which Shopify treats slightly differently. */
        if (Object.keys(payload.properties).length === 0) {
          delete payload.properties;
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error();
        atcBtn.innerHTML = '✓ Added!';
        atcBtn.style.background = '#22C55E';
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-icon-bubble span').forEach(el => {
          el.textContent = cart.item_count;
        });
        setTimeout(() => { atcBtn.innerHTML = orig; atcBtn.disabled = false; atcBtn.style.background = ''; }, 2000);
      } catch {
        atcBtn.innerHTML = orig;
        atcBtn.disabled = false;
        form.submit();
      }
    });

    if (!document.getElementById('rbi-keyframes')) {
      const s = document.createElement('style');
      s.id = 'rbi-keyframes';
      s.textContent = '@keyframes rbi-spin { to { transform: rotate(360deg); } }';
      document.head.appendChild(s);
    }

  }

  /* ── Helpers ──────────────────────────────────────────────── */
  function eh(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function ea(s) { return String(s).replace(/"/g,'&quot;'); }
  function debounce(fn, ms) { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; }

})();